import i18n from '@/lang/i18n'

export default {
    links: [
        {
            to: { name: 'Admin' },
            text: i18n.t('navigation.admin'),
        },
    ],
}
